<template>
  <div class="active-list-wrap">
      <!-- 头部 -->
      <top></top>
      <el-row class="hidden-sm-and-up">
        <el-col>
          <div class="mineNav-left">
            <ul class="mineNav">
              <li @click="toPath('/mine')">{{$t('exhibitor.personal')}}</li>
              <li @click="show(0)">
                <p>{{$t('exhibitor.collect')}} <i class="el-icon-arrow-down"></i></p>
                <ul class="minesubnav" v-if="isSHowSub">
                  <li @click.stop="collectMChange(0)">{{$t('exhibitor.product')}}</li>
                  <li @click.stop="collectChange(1)">{{$t('exhibitor.enterprise')}}</li>
                  <li class="active" @click.stop="collectMChange(2)">{{$t('navMenu.active')}}</li>
                </ul>
              </li>
              <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} 
                  <i class="el-icon-arrow-down"></i>
                </p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandMChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandMChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandMChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
              </li> -->
              <li @click="toPath('/feedback')">{{$t('exhibitor.feedback')}}</li>
              <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
            </ul>
          </div>
        </el-col>
      </el-row>
      <el-row class="exmain">
        <el-col :xs="xsNumLeft" :sm="xsNumLeft" :md="3" :lg="3" :xl="4"></el-col>
        <el-col :xs="xsNumLeftNav" :sm="xsNumLeftNav" :md="5" :lg="2" :xl="2" class="hidden-sm-and-down">
          <div class="mineNav-left">
            <ul class="mineNav">
              <li @click="toPath('/mine')">{{$t('exhibitor.personal')}}</li>
              <li @click="show(0)">
                <p>{{$t('exhibitor.collect')}} <i class="el-icon-arrow-right"></i></p>
                <ul class="minesubnav" v-if="isSHowSub">
                  <li @click.stop="collectChange(0)">{{$t('exhibitor.product')}}</li>
                  <li @click.stop="collectChange(1)">{{$t('exhibitor.enterprise')}}</li>
                  <li class="active" @click.stop="collectChange(2)">{{$t('navMenu.active')}}</li>
                </ul>
              </li>
              <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} <i class="el-icon-arrow-right"></i></p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
              </li> -->
              <li @click="toPath('/feedback')">{{$t('exhibitor.feedback')}}</li>
              <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
            </ul>
          </div>
        </el-col>
        <el-col :xs="xsNum" :sm="xsNum" :md="14" :lg="14" :xl="10">
          <div class="main-right alistwrap" :style="{minHeight:height}" >
            <div class="alist myalist" v-if="activeList.length > 0">
              <div class="alist-item" v-for="item in activeList" :key="item.id" @click="toDetail(item.id)">
                  <img v-if="item.thumb.length > 0" :src="$imgUrl + item.thumb" alt="">
                  <img v-else src="../../../assets/active_default.jpg" alt="">
                  <div class="atext">
                      <p class="time">{{item.ymd}} {{item.time_1}}:{{item.time_2}}</p>
                      <p v-if="langSet == 'zh' || item.en_address.length == 0" class="address">{{item.address}}</p>
                      <p v-if="langSet == 'en' && item.en_address.length > 0" class="address">{{item.en_address}}</p>
                      <p v-if="langSet == 'zh' || item.en_title.length == 0" class="title">{{item.title}}</p>
                      <p v-if="langSet == 'en' && item.en_title.length > 0" class="title">{{item.en_title}}</p>
                      <p class="detail">{{$t('exhibitor.activeDetails')}} ></p>
                  </div>
              </div>
          </div>
          <el-pagination
              background
              v-if="activeList.length > 0"
              :page-size = pagesize
              layout="total,prev, pager, next"
              @current-change="changePage"
              :total="total">
          </el-pagination>
            <div class="nodata" v-if="activeList.length == 0">
              <img v-if="langSet == 'zh'" src="../../../assets/nodata.png" alt="">
              <img v-else src="../../../assets/nodata01.png" alt="">
            </div>
          </div>
        </el-col>
        <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="4"></el-col>
      </el-row>
      <!-- 底部 -->
      <bottom></bottom>
  </div>
</template>

<script>
import top from "../../../components/top.vue";
import bottom from "../../../components/bottom.vue";
import { getActivityitem } from "@/api/api";
export default {
  components: { top,  bottom},
  name: "mine",
  data() {
    return {
      isSHowSub:true,
      isSHowSubDemand:false,
      activeList: [],
      page: 1,
      pagesize: 10,
      total:0,
      height: '',
      langSet: '',
      xsNumLeft: 1,
      xsNumLeftNav: 4,
      xsNum: 18
    }
  },
  created() {
  },
  mounted() {
    this.langSet = localStorage.getItem('languageSet') || 'zh';
    this.memberid = localStorage.getItem('memberid');
    this.getActivitylist(this.page);
    this.setHeight();
    if(this._isMobile()) {
      this.isSHowSub = false;
      this.xsNumLeft = 1;
      this.xsNumLeftNav = 0;
      this.xsNum = 22;
    }else{
      this.isSHowSub = true;
      this.xsNumLeft = 1;
      this.xsNumLeftNav = 4;
      this.xsNum = 18;
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    collectMChange(index){
      if(index == 0){
        this.$router.push({
          name: 'myproduct'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'mycompany'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'myactive'
        });
      }
      this.isSHowSub = !this.isSHowSub;
    },
    demandMChange(index){
      if(index == 0){
        this.$router.push({
          name: 'demandissue'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'myresponse'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'mymessage'
        });
      }
      this.isSHowSubDemand = !this.isSHowSubDemand;
    },
    setHeight(){
        this.height = window.innerHeight  - 145 + 'px';
    },
    show(id){
      if(id == 0){
        this.isSHowSub = !this.isSHowSub;
      }else{
        this.isSHowSubDemand = !this.isSHowSubDemand;
      }
    },
    getActivitylist(page){
        let data = this.$qs.stringify({
          memberid: this.memberid,
          act: "collect",
          pagesize: this.pagesize,
          page: this.page
        })
        getActivityitem(data).then(res=>{
            //console.log(res.data)
            if(res.data.errno == 0){
                this.activeList = res.data.rst;
                this.total = Number(res.data.errmsg);
                //console.log(this.activeList)
            }
        }).catch(err=>{
            console.log(err)
        })
    },
    changePage(val){
      this.page = val;
      this.getActivitylist(this.page);
    },
    collectChange(index){
      if(index == 0){
        this.$router.push({
          name: 'myproduct'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'mycompany'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'myactive'
        });
      }
    },
    demandChange(index){
      if(index == 0){
        this.$router.push({
          name: 'demandissue'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'myresponse'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'mymessage'
        });
      }
    },
    toDetail(id){
        this.$router.push({path: '/activedetail',query:{id}});
    },
    toPath(path){
      this.$router.push({path});
    }
  }
}
</script>

<style lang="scss" scoped>
.exmain .main-right{box-sizing: border-box;}
.main{padding-top: 40px;padding-left: 184px;}
.mineNav > li{font-size:20px;line-height:28px;color: #000;margin-bottom: 24px;cursor: pointer;width: 100px;text-align: center;}
.mineNav > li.active{color: #CAC28A;}
.mineNav > li p{position: relative;}
.mineNav > li p i{position: absolute;top: 5px;}
.mineNav > li .minesubnav{color: #666;font-size:18px;line-height: 25px;padding-bottom: 13px;text-align: center;}
.mineNav > li .minesubnav li{padding-top: 14px;}
.mineNav > li .minesubnav .active{color: #CAC28A;}

.alistwrap .alist{min-height: 600px;margin: 0 !important;}
.alistwrap .myalist{column-count: 4;column-gap: 10;}
.alistwrap .alist .alist-item{padding-bottom: 20px;cursor: pointer;break-inside: avoid;}
.alistwrap .alist img{width: 100%;height:100%;border-radius:9px;}
.alistwrap .alist .atext .time{font-size: 20px;line-height:28px;color: #000;}
.alistwrap .alist .atext .address{font-size: 14px;line-height:20px;color: #333;}
.alistwrap .alist .atext .title{font-size: 18px;line-height:20px;color: #333;height: 38px;overflow: hidden;font-weight: bold;}
.alistwrap .alist .atext .detail{font-size: 14px;line-height:20px;color: #CAC28A;cursor: pointer;}
.alistwrap .el-pagination{text-align: center;background: #EEE;padding: 6px 5px;height: 52px;box-sizing: border-box;}
.alistwrap .el-pagination button, .alistwrap .el-pagination span:not([class*=suffix]){height: 36px;line-height: 40px;font-size:18px;color: #666;}
.alistwrap .el-pager li{font-size: 18px;color: #666;}
.alistwrap .el-pagination.is-background .btn-next, .alistwrap .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{background-color:#fff;border-radius: 50%;}
.alistwrap .el-pagination.is-background .el-pager li{width: 41px;height: 41px;line-height: 41px;}
.alistwrap .el-pagination.is-background .el-pager li:not(.disabled).active,.alistwrap .el-pager li.active{background-color:#CAC28A;color: #fff !important;}
.alistwrap .el-pagination.is-background .btn-next, .alistwrap .el-pagination.is-background .btn-prev{background-color: transparent;}
.alistwrap .el-pagination .btn-next .el-icon, .alistwrap .el-pagination .btn-prev .el-icon{font-size: 20px;}
.alistwrap .el-pagination.is-background .el-pager li:not(.disabled):hover{color:#CAC28A;}
.nodata{padding-top: 200px;}
.mineNav > li.inbox{background:rgba(224,153,149,1);border-radius:4px;color: #fff;font-size: 18px;}

@media only screen and (max-width: 767px){
  .mineNav{
    padding: 0 0.2rem;
    display: flex;
    margin-top: 0.2rem;
    li.inbox{font-size: 11px;}
    li{
      font-size: 11px;
      flex: 1;
      position: relative;
      margin-bottom: 0;
      p i{top: 0.18rem;}
      .minesubnav{
        font-size: 11px;
        line-height: 0.25rem;
        position: absolute;
        background: #fff;
        width: 100%;
        z-index: 999;
        li{padding-top: 0.14rem;}
      }
    } 
  }
  .nodata{width: 75%;}
  .alist-item{width: 100%;}
  .alistwrap .myalist{column-count: 1;column-gap: 0;}
  .alistwrap .alist .atext .time{font-size: 15px;}
  .alistwrap .alist .atext .title{font-size: 15px;}
  .alistwrap .alist .atext .address{font-size: 12px;}
  .alistwrap .el-pagination{height: 0.52rem;padding:0.05rem;}
  .alistwrap .el-pagination button, .alistwrap .el-pagination span:not([class*=suffix]){height: 0.36rem;line-height: 0.36rem;font-size: 12px;}
  .alistwrap .el-pagination.is-background .el-pager li {width: 0.41rem;height: 0.41rem;line-height: 0.41rem;}
  .alistwrap .el-pager li{font-size: 12px;}
  .el-pager, .el-pager li{vertical-align: middle;}
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{min-width: auto;}
  .alistwrap .el-pagination .btn-next .el-icon, .alistwrap .el-pagination .btn-prev .el-icon{font-size: 18px;}
}
</style>